import { inject, Injectable } from '@angular/core';

import { type RuntimeContext } from '@blaze-shared/elements-domain';
import { IntelliSenseService } from '@blaze-shared/intellisense-feature';
import { type ExecuteJavascriptWorkflowNode } from '@blaze-shared/workflow-domain';

/** Runs the node's script against its input, and resolves with whatever the script returns. */
@Injectable({ providedIn: 'root' })
export class ExecuteJavascriptActionService {
  private readonly iss = inject(IntelliSenseService);

  async executeJavascript(
    node: ExecuteJavascriptWorkflowNode,
    nodeInput: any,
    ctx: RuntimeContext,
  ): Promise<any> {
    const context = this.iss.updateRuntimeContext(ctx, nodeInput);
    return await this.iss.evalAsync(node.value || '', context);
  }
}
